<template>

<app-page>

	<core-filter-bar v-if="!is.loading && is.initialised">

		<core-filter-bar-left>

			<core-filter-summary title="Daily Group Syncs" icon="users" />

		</core-filter-bar-left>

	</core-filter-bar>

	<core-content-page>

		<core-content-wrapper :loading="is.loading && !is.initialised">

			<div class="items" :class="{'is-hidden': is.loading && !is.initialised}">

				<div class="item is-intro" key="intro">

					<div class="item-text">

                        <p>You can nominate a group to receive your <b>Daily Group Syncs</b> perk to allow up to 25 non-patreon users in the group to also have their data update every day.</p>

                        <p>The users receiving the perk will only have their data updated daily in the nominated group and not their personal profiles.</p>

                        <p>For larger groups, the 25 users that receive the perk will be selected by the system automatically. Multiple Group Leader patreons can contribute their perk to the same group to cover more users.</p>

					</div>

				</div>

				<div class="item is-group is-unassigned" key="unassignedgroup" v-if="!data.group">

                    <h2>Group</h2>

                    <div><i class="fa fa-users item-icon" /></div>

					<div class="item-actions">

                        <core-button theme="white" text="Choose group" class="item-button" v-on:click="onChooseClick" />

                    </div>

				</div>

				<div class="item is-group is-assigned" key="group" v-if="data.group">

                    <h2>{{ groupName }}<small>Nominated group</small></h2>

                    <div><i class="fa fa-users item-icon" /></div>

					<div class="item-actions" v-if="data.group.canRemove">

                        <core-button theme="whitegreen" text="Remove" v-on:click="onRemoveClick" />

                    </div>

					<p v-if="!data.group.canRemove">Can change {{ data.group.removeDate | fromNow }}.</p>

				</div>

			</div>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {
	
		return {

			data: {},

			is: {
				initialised: false,
				loading: true
			},

			timer: false

		}
	
	},

	created: function() {

		this.load()
	
		this.$pubsub.$on('session.patreon.syncs', this.reload.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('session.patreon.syncs', this.reload.bind(this))

	},

	computed: {

		groupName: function() {

			return (this.data.group) ? this.$_.findWhere(this.$store.getters['session/groups'], {
				id: this.data.group.recipient
			}).name : ''

		}

	},

	methods: {
	
		load: function() {
		
			this.is.loading = true

			this.$api.get('session/groupsyncs').then(function(json) {

				Vue.set(this, 'data', json)

				this.is.initialised = true

				this.is.loading = false
			
			}.bind(this))
		
		},
	
		reload: function() {
		
			this.is.initialised = false

			this.load()
		
		},

		onChooseClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonSyncsChoose')

		},

		onRemoveClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonSyncsRemove')

		}

	}

}

</script>

<style scoped>

.items {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto;
	grid-gap: 40px;
}

.is-smaller .items {
	grid-gap: 20px;
}

.is-tablet .items {
	grid-gap: 20px;
	grid-template-columns: 1fr 1fr;
}

.is-mobile .items {
	grid-template-columns: 1fr;
	grid-gap: 20px;
	padding: 20px;
}

.items.is-hidden {
	opacity: 0;
}

.item {
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 20px;
    min-height: 320px;
}

.is-mobile .item.is-intro {
	min-height: auto;
}

.item-image {
	height: 180px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
}

.item.is-intro .item-text {
	height: 100%;
}

.item-text p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 20px;
}

.item-text p i {
	font-style: italic;
}

.item-text p:last-child {
	margin-bottom: 0px;
}

.item-date {
	font-size: 14px;
	line-height: 14px;
	font-weight: 400;
	color: #999;
	margin-bottom: 10px;
}

.item-button {
	width: 100%;
}

.item.is-user,
.item.is-group {
    text-align: center;
    display: grid;
    grid-template-rows: auto 1fr auto;
}

.item.is-assigned,
.item.is-user {
    background-color: #48bb6d;
    color: #fff;
}

.item.is-building {
    background-color: #de8635;
    color: #fff;
}

.item.is-unassigned {
    background-color: #bb4848;
    color: #fff;
}

.item h2 {
    font-size: 24px;
    font-weight: 500;
}

.item h2 small{
    font-size: 16px;
	display: block;
    font-weight: 300;
	margin-top: 4px;
}

.item-icon {
    font-size: 128px;
    position: absolute;
    top: 50%;
    left: 50%;
	width: 200px;
	height: 128px;
	margin-left: -100px;
	margin-top: -64px;
}

.is-mobile .item-icon {
	font-size: 96px;
	margin-top: -48px;
	height: 96px;
}

.item.is-locked .item-icon {
    color: #ccc;
}

.item.is-group p,
.item.is-user p {
    font-size: 16px;
	line-height: 20px;
	padding: 10px 0px;
    font-weight: 400;
}

.item.is-group p small {
	font-size: 14px;
	display: block;
	opacity: 0.75;
}

.item-actions {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;
}

.item-subtext {
	font-weight: 400;
	font-size: 14px;
}

</style>